import React, { useState } from 'react';
import PersonInputModal from './PersonInputModal';

const ModifyProduct = ({ formData, onSubmit, onDelete, onClose, onAddition }) => {
    const [modifiedData, setModifiedData] = useState(formData || {
        woodType: '',
        length: '',
        depth: '',
        thickness: '',
        limit: '',
        amount: '',
        handRail_woodType: '',
        handRailModel: '',
        isHandRail: false,
        item: '',
        info: ''
    });
    const [showPersonModal, setShowPersonModal] = useState(false);
    const [showPersonModalDeletion, setShowPersonModalDeletion] = useState(false);
    const [showPersonModalAddition, setShowPersonModalDAddition] = useState(false);
    const [isAddition, setIsAddition] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setModifiedData({ ...modifiedData, [name]: type === 'checkbox' ? checked : value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowPersonModal(true); // Show the person input modal
    };

    const handlePersonConfirm = (name) => {
        if (isAddition) {
            onAddition(modifiedData, name);
        } else {
            onSubmit(modifiedData, name); // Pass the person's name to onSubmit
        }
        setShowPersonModal(false);
        onClose(); // Close the ModifyProduct window after submission
    };

    const handlePersonCancel = () => {
        setShowPersonModal(false);
        setShowPersonModalDeletion(false);
        setShowPersonModalDAddition(false);
    };

    const handleDelete = () => {
        // Show the delete confirmation modal
        setShowPersonModalDeletion(true);
    };

    const handlePersonConfirmDelete = (person) => {
        onDelete(modifiedData._id, person);
        setShowPersonModal(false);
        onClose(); // Close the ModifyProduct window after deletion
    }

    const handleCancel = () => {
        onClose(); // Close the ModifyProduct window on cancel
    };

    const handleAddition = () => {
        setIsAddition(true);
        setShowPersonModalDAddition(true);
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-window modal-window--narrow">
                <h2 className="modal-title">Muokkaa tuotetta</h2>
                <form onSubmit={handleSubmit} className="modal-form">
                    <div className="modal-form__column">
                        {modifiedData.item ? (
                            <>
                                <label htmlFor="woodtype-input">Tuoteryhmä:</label>
                                <input
                                    type="text"
                                    name="woodType"
                                    value={modifiedData.woodType}
                                    onChange={handleChange}
                                    required
                                    placeholder="Esim. 'Q-Railing' tai 'Muut'"
                                    className="modal-input"
                                />
                                <label htmlFor="item">Tuote:</label>
                                <input
                                    type="text"
                                    name="item"
                                    value={modifiedData.item}
                                    onChange={handleChange}
                                    required
                                    className="modal-input"
                                />
                                <label htmlFor="info">Tiedot:</label>
                                <input
                                    type="text"
                                    name="info"
                                    value={modifiedData.info}
                                    onChange={handleChange}
                                    className="modal-input"
                                />
                            </>
                        ) : modifiedData.woodType === 'Käsijohteet' ? (
                            <>
                                <label htmlFor="handRail_woodType">Kaiteen puulaji:</label>
                                <input
                                    type="text"
                                    name="handRail_woodType"
                                    value={modifiedData.handRail_woodType}
                                    onChange={handleChange}
                                    required
                                    className="modal-input"
                                />
                                <label htmlFor="handRailModel">Kaiteen malli:</label>
                                <input
                                    type="text"
                                    name="handRailModel"
                                    value={modifiedData.handRailModel}
                                    onChange={handleChange}
                                    required
                                    className="modal-input"
                                />
                                <label htmlFor="length">Pituus:</label>
                                <input
                                    type="text"
                                    name="length"
                                    value={modifiedData.length}
                                    onChange={handleChange}
                                    required
                                    className="modal-input"
                                />
                            </>
                        ) : (
                            <>
                                <label htmlFor="woodType">Puulaji:</label>
                                <input
                                    type="text"
                                    name="woodType"
                                    value={modifiedData.woodType}
                                    onChange={handleChange}
                                    required
                                    className="modal-input"
                                />
                                <label htmlFor="length">Pituus:</label>
                                <input
                                    type="text"
                                    name="length"
                                    value={modifiedData.length}
                                    onChange={handleChange}
                                    required
                                    className="modal-input"
                                />
                                <label htmlFor="depth">Leveys:</label>
                                <input
                                    type="text"
                                    name="depth"
                                    value={modifiedData.depth}
                                    onChange={handleChange}
                                    required
                                    className="modal-input"
                                />
                            </>
                        )}
                    </div>
                    <div className="modal-form__column">
                        {!modifiedData.item && modifiedData.woodType !== 'Käsijohteet' && (
                            <>
                                <label htmlFor="thickness">Paksuus:</label>
                                <input
                                    type="text"
                                    name="thickness"
                                    value={modifiedData.thickness}
                                    onChange={handleChange}
                                    required
                                    className="modal-input"
                                />
                            </>
                        )}
                        <label htmlFor="limit">Varmuusraja:</label>
                        <input
                            type="text"
                            name="limit"
                            value={modifiedData.limit}
                            onChange={handleChange}
                            required
                            className="modal-input"
                        />
                        <label htmlFor="amount">Määrä:</label>
                        <input
                            type="number"
                            name="amount"
                            value={modifiedData.amount}
                            onChange={handleChange}
                            required
                            min="0"
                            className="modal-input"
                        />
                    </div>
                    <div className="modal-form__row modal-actions--between">
                        <button type="button" className="btn btn-danger" onClick={handleDelete}>Poista tuote</button>
                        <button type="button" className="btn btn-ghost" onClick={handleAddition}>Lisää uutena tuotteena</button>
                    </div>
                    <div className="modal-form__row modal-actions--between">
                        <button type="button" className="btn btn-ghost" onClick={handleCancel}>Peru</button>
                        <button type="submit" className="btn btn-primary">Tallenna muutokset</button>
                    </div>
                </form>
            </div>
            {showPersonModal && <PersonInputModal item={"Muokkaa tuotetta"} onConfirm={handlePersonConfirm} onCancel={handlePersonCancel} />}
            {showPersonModalDeletion && <PersonInputModal item={"Poista tuote"} onConfirm={handlePersonConfirmDelete} onCancel={handlePersonCancel} />}
            {showPersonModalAddition && <PersonInputModal item={"Lisää uusi tuote"} onConfirm={handlePersonConfirm} onCancel={handlePersonCancel} />}
        </div>
    );

};

export default ModifyProduct;